import { render, staticRenderFns } from "./CopyPasteModal.vue?vue&type=template&id=2c899767&scoped=true&lang=pug"
import script from "./CopyPasteModal.vue?vue&type=script&lang=js"
export * from "./CopyPasteModal.vue?vue&type=script&lang=js"
import style0 from "./CopyPasteModal.vue?vue&type=style&index=0&id=2c899767&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c899767",
  null
  
)

export default component.exports